import { graphql } from 'gatsby';
import propType from 'prop-types';
import React from 'react';

import ArticlesGrid from '../../components/ArticlesGrid';
import Banner from '../../components/Banner';
import Breadcrumb from '../../components/BravoBreadcrumb';
import HeaderNavigation from '../../components/HeaderNavigation';
import HelmetComponent from '../../components/Helmet';
import PostSearchBar from '../../components/PostSearchBar';
import Footer from './components/Footer';

const BlogCategory = ({ data, location }) => {
  const { wpCategory: category } = data;

  return (
    <>
      <HelmetComponent
        title={`${category.name} - Online HR Management Software`}
      />
      <HeaderNavigation type="special" />
      <main id="blog-category">
        <Banner title={category.name} />
        <Breadcrumb breadcrumb={category.seo.breadcrumbs} />
        <PostSearchBar from={location.pathname} category={category.slug} />
        <ArticlesGrid
          category={category.slug}
          posts={category.postsByCategory}
        />
      </main>
      <Footer />
    </>
  );
};

export default BlogCategory;

BlogCategory.propTypes = {
  data: propType.shape({
    wpCategory: propType.shape({
      name: propType.string.isRequired,
      postsByCategory: propType.arrayOf(propType.shape({})).isRequired,
      seo: propType.shape({
        breadcrumbs: propType.arrayOf(propType.shape({}))
      }).isRequired,
      slug: propType.string.isRequired
    })
  }).isRequired,
  location: propType.shape({
    pathname: propType.string
  }).isRequired
};

export const query = graphql`
  query CategoryPage($id: String!) {
    wpCategory(id: { eq: $id }) {
      id
      name
      uri
      slug
      seo {
        breadcrumbs {
          text
          url
        }
      }
      postsByCategory {
        id
        title
        uri
        dateGmt(formatString: "MMMM DD, YYYY")
        excerpt
        categories {
          nodes {
            id
            name
            slug
            uri
            pillarPost {
              id
              uri
              title
              customPostField {
                topic
              }
            }
          }
        }
        tags {
          nodes {
            id
            name
            slug
          }
        }
        featuredImage {
          node {
            localFile {
              ...HeroImage
            }
          }
        }
      }
    }
  }
`;
